module.exports = [{
      plugin: require('/zeit/66248dfe/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
